/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { DownloadIcon, SearchIcon, ViewIcon } from '../../../../assets/icons';
import { Constants, formatAmount, formatMiles, fromStorage, getUpdatedState } from '../../../../utils';
import { Input, Modal, Pagination, Select } from '../../../../components';
import { BillingService } from '../../../../services';
import ModalPay from '../modal-pay';
import ModalFilter from './modal-filter';

const MODAL = {
  NONE: 0,
  FILTER: 1,
  PAY: 2,
  VIEW: 3,
}

const BillingClient = () => {
  const [modal, setModal] = useState(MODAL.NONE);
  const [selectedItem, setSelectedItem] = useState(null);
  const { data, filters, goToPage, onChange, downloadAll, downloadOne, onFillFilters, pagination, reload, search, selects } = useFetchTable();

  const onSelectItem = (modal, item = null) => {
    setSelectedItem(item);
    setModal(modal);
  };

  return (
    <main className="w-full">
      <Modal isOpen={modal === MODAL.FILTER} onClose={() => onSelectItem(MODAL.NONE)}>
        <ModalFilter
          filters={filters}
          onClose={() => onSelectItem(MODAL.NONE)}
          onSubmit={onFillFilters}
        />
      </Modal>

      <Modal isOpen={modal === MODAL.PAY} onClose={() => onSelectItem(MODAL.NONE)}>
        {modal === MODAL.PAY && (
          <ModalPay
            destiny={Constants.BILLING.DESTINY.CLIENT}
            data={data}
            onClose={() => onSelectItem(MODAL.NONE)}
            onSuccess={reload}
          />
        )}
      </Modal>

      <Modal isOpen={modal === MODAL.VIEW} onClose={() => onSelectItem(MODAL.NONE)}>
        <div className="w-[30rem] mx-auto bg-white p-6 rounded-2xl font-sans antialiased selection:bg-orange-100 relative">
          <button
            type="button"
            className="p-1.5 rounded-full hover:bg-gray5 transition-colors absolute top-2 right-2"
            onClick={() => onSelectItem(MODAL.NONE)}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
            </svg>
          </button>

          <div className="mb-4">
            <h3 className="text-xl text-center font-bold mb-4 text-gray-900">Pago</h3>
          </div>

          <div>
            <p className="text-xl">
              <span className="text-[#A7A7A7] font-bold">Total pagado </span>{ formatAmount(selectedItem?.payment?.amount_local, 'Bs. ') }
            </p>
            <p><span className="font-bold">Banco</span> { selectedItem?.payment?.bank?.name }</p>
            <p><span className="font-bold">N° de referencia</span> { selectedItem?.payment?.reference }</p>
            <p><span className="font-bold">Fecha de pago</span> { moment(selectedItem?.payment?.date).format('DD-MM-YYYY') }</p>

            <div className="flex justify-center items-center gap-6 mt-8">
              <button
                onClick={() => onSelectItem(MODAL.NONE)}
                className="text-[#A3A3A3] font-bold text-lg hover:text-gray-600 transition-all duration-200"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      </Modal>

      <div className="flex flex-col md:flex-row md:items-center justify-between gap-4 mb-6">
        <div className="flex flex-1 flex-wrap items-end gap-3">
          <Input
            className={{ base: 'max-w-60' }}
            placeholder="Buscar nombre, CI o RIF"
            value={filters.search}
            onValueChange={v => onChange('search', v)}
            prepend={
              <img src={SearchIcon} className="w-4 h-4" alt="" />
            }
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Desde"
            value={filters.since}
            onValueChange={v => onChange('since', v)}
          />

          <Input
            className={{ base: 'max-w-44' }}
            type="date"
            label="Hasta"
            value={filters.until}
            onValueChange={v => onChange('until', v)}
          />

          <Select
            className={{ base: 'max-w-44' }}
            placeholder="Estatus"
            items={selects.status}
            value={filters.status}
            onValueChange={v => onChange('status', v)}
          />

          <div className="flex gap-4">
            <button
              className="bg-red hover:bg-red-700 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => {
                onChange('isFilteringToPay', false);
                search();
              }}
            >
              Filtrar
            </button>
            <button
              className="bg-black hover:bg-gray-800 text-white px-6 py-2 rounded-full text-sm font-medium transition-colors"
              onClick={() => reload()}
            >
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <div className="flex justify-end items-start">
        <div>
          <div className="flex gap-2 mb-2">
            <button
              className="flex items-center gap-2 bg-orange text-white px-4 py-1.5 rounded-lg font-semibold disabled:bg-gray6 disabled:text-gray5"
              onClick={() => onSelectItem(MODAL.PAY)}
              disabled={!filters.isFilteringToPay || !data.length}
            >
              Pagar
            </button>
            <button
              className="flex items-center gap-2 bg-red text-white px-4 py-1.5 rounded-lg font-semibold"
              onClick={() => onSelectItem(MODAL.FILTER)}
            >
              Filtrar para cobrar
            </button>
          </div>

          <TotalToPay data={data} isFilteringToPay={filters.isFilteringToPay} />
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-md overflow-hidden mt-6">
        <div className="flex items-center justify-between py-4 px-3">
          <p className="text-2xl font-bold text-center">Registros de comisiones</p>

          <button
            className="flex items-center gap-2 bg-black text-white px-4 py-1.5 rounded-lg font-semibold"
            onClick={() => toast.promise(downloadAll(), { loading: 'Descargando...', success: 'Reporte descargado con éxito', error: 'Error al descargar el reporte' })}
          >
            <img src={DownloadIcon} className="w-4 h-4 brightness-200" alt="" />
            Descargar
          </button>
        </div>

        <div className="overflow-x-auto">
          <table className="text-left border-collapse w-full">
            <thead>
              <tr className="border-b border-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:break-words [&>th]:max-w-36 text-default font-semibold align-bottom">
                <th><span className="pl-4">Fecha del viaje</span></th>
                <th>Ruta</th>
                <th>Cliente</th>
                <th>CI/RIF</th>
                <th>Propietario</th>
                <th>Monto Facturado</th>
                <th>Estatus de pago</th>
                <th>Acción</th>
              </tr>
            </thead>
            <tbody className="text-sm text-text">
              {data.map((item, index) => (
                <tr key={index} className="hover:bg-gray5 transition-colors odd:bg-gray5 [&>td]:py-3 [&>td]:px-1 [&>td]:truncate [&>td]:max-w-36">
                  <th><span className="pl-4">{ moment(item?.order?.date).format('DD-MM-YYYY') }</span></th>
                  <td>{ item?.order?.route?.name }</td>
                  <td>{ item?.order?.user?.person?.company?.name }</td>
                  <td>{ item?.order?.user?.person?.company?.documentType?.name || '' }{ item?.order?.user?.person?.company?.document }</td>
                  <td>{ item?.order?.vehicle?.owner?.person?.name || 'Maxer' }</td>
                  <td>
                    <p className="font-semibold">{ formatMiles(item?.amount, true, '$') }</p>
                    <p className="text-sm">{ formatMiles(item?.amount_local, true, 'Bs. ') }</p>
                  </td>
                  <td className="text-black font-bold data-[status=0]:text-red" data-status={item?.status}>
                    { item?.status_text }
                  </td>
                  <td>
                    <div className="flex justify-end gap-3 pr-2">
                      {item?.status === Constants.BILLING.STATUS.PAID && (
                        <img
                          src={ViewIcon}
                          className="w-5 h-5 object-contain cursor-pointer"
                          onClick={() => onSelectItem(MODAL.VIEW, item)}
                          alt=""
                        />
                      )}
                      <img
                        src={DownloadIcon}
                        className="w-5 h-5 object-contain cursor-pointer"
                        onClick={() => {
                          toast.promise(
                            downloadOne(item?.id),
                            {
                              loading: 'Descargando...',
                              success: 'Reporte impreso con éxito',
                              error: 'Error al imprimir el reporte',
                            }
                          );
                        }}
                        alt=""
                      />
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!data.length && (
            <p className="py-8 text-text text-center">No se han encontrado registros</p>
          )}
        </div>

        <div className="px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-4">
          <Pagination
            active={pagination.page}
            pages={pagination.pages}
            onChange={goToPage}
          />
        </div>
      </div>
    </main>
  );
};

const TotalToPay = ({ data, isFilteringToPay }) => {
  const totals = useMemo(() => {
    const totals = {
      amount: 0,
      amount_local: 0,
    }

    if (!isFilteringToPay) return totals;

    data.forEach(item => {
      if (item.status === Constants.BILLING.STATUS.PAID) return;
      totals.amount += Number(item.amount);
      totals.amount_local += Number(item.amount_local);
    });

    return totals;
  }, [data, isFilteringToPay]);

  return (
    <div className="text-right font-semibold">
      <p className="text-4xl">{ formatAmount(totals.amount, '$') }</p>
      <p className="text-2xl">{ formatAmount(totals.amount_local, 'Bs. ') }</p>
    </div>
  )
}

const useFetchTable = () => {
  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    destiny: Constants.BILLING.DESTINY.CLIENT,
    isFilteringToPay: false,
    user_id: '',
    search: '',
    since: '',
    until: '',
    status: '',
  };

  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };

  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);
  const [selects] = useState({
    status: [
      { value: Constants.BILLING.STATUS.PENDING, label: 'Pendiente' },
      { value: Constants.BILLING.STATUS.PAID, label: 'Pagado' },
    ],
  });

  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const payload = await getUpdatedState(setFilters);
      const response = await BillingService.admin.findAll(payload);
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      setCanFetch(true);
    }
  }

  const downloadAll = async () => {
    try {
      const response = await BillingService.admin.downloadAll(filters);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    } catch (error) {
      console.log(error);
    }
  }

  const downloadOne = async (id) => {
    try {
      const response = await BillingService.admin.downloadOne(id);
      if (response?.url) {
        const link = document.createElement('a');
        link.href = fromStorage(response.url);
        link.target = '_blank';
        link.download = response.url.split('/').pop();
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.log(error);
    }
  }

  const onFillFilters = (form) => {
    setFilters(s => ({ ...s, ...form }));
    fetchData();
  }

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    fetchData();
  }

  const goToPage = async (page) => {
    const pagination = await getUpdatedState(setPagination);
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
      fetchData();
    }
  }

  const onChange = (target, value) => {
    setFilters(s => ({ ...s, page: 1, [target]: value }));
  }

  useEffect(() => {
    fetchData();
  }, []);

  return {
    data,
    downloadAll,
    downloadOne,
    filters,
    goToPage,
    isLoading: !canFetch,
    onChange,
    onFillFilters,
    pagination,
    reload,
    search: fetchData,
    selects,
  }
}

export default BillingClient;